import AdminOnly from "#/components/auth/AdminOnly";
import ArticleAiPolicyEditor from "#/admin/article-policy/components/ArticleAiPolicyEditor";

export default function AdminArticleAiPolicyPage() {
  return (
    <AdminOnly>
      <div className="container mx-auto flex flex-col gap-5 px-4 py-6">
        <ArticleAiPolicyEditor />
      </div>
    </AdminOnly>
  );
}
